import { ArrowLeft, ArrowRight, Edit3, Home, Package, MapPin, Settings, User, Send } from "lucide-react";
import Summary from "../components/Summary";

export default function Step6({ data, back, submit }) {
  const sections = [
    ["Move Information", [["Moving Type", data.moveType || "Residential Move"], ["Moving Date", data.date || "Not selected"], ["House Type", data.houseType || "Not selected"]], Home],
    ["Items & Inventory", [["Total Items", `${Object.values(data.items || {}).reduce((a, b) => a + b, 0)} items`], ["Major Items", "Sofa, Bed, TV, Refrigerator"]], Package],
    ["Pickup & Delivery", [["Pickup Location", data.from || "Chennai, Tamil Nadu"], ["Delivery Location", data.to || "Bangalore, Karnataka"], ["Loading Distance", "Less than 50 meters"], ["Unloading Distance", "Less than 50 meters"]], MapPin],
    ["Additional Services", [["Selected Services", (data.services || []).join(", ") || "None"], ["Total Services", `${(data.services || []).length} services`]], Settings],
    ["Your Details", [["Full Name", data.name || "Not provided"], ["Mobile Number", data.phone || "Not provided"], ["Email Address", data.email || "Not provided"], ["WhatsApp Number", data.whatsapp || data.phone || "Not provided"]], User]
  ];

  return (
    <div className="page-grid with-summary">
      <main className="form-card">
        <h2>6. Review & Get Quote</h2>
        <p className="section-subtitle">Please review all the information below. If you need to make changes, you can go back to the respective steps and edit.</p>
        {sections.map(([title, rows, Icon]) => (
          <div className="review-section" key={title}>
            <div className="review-head"><h3><Icon size={20} />{title}</h3><button><Edit3 size={14} /> Edit</button></div>
            {rows.map(([k, v]) => <div className="review-row" key={k}><span>{k}</span><b>:</b><strong>{v}</strong></div>)}
          </div>
        ))}
        <div className="actions"><button className="back ghost" onClick={back}><ArrowLeft size={17} /> Back</button><button className="primary large" onClick={submit}><Send size={17} /> Submit Quote Request <ArrowRight size={18} /></button></div>
      </main>
      <Summary data={data} total={18500} />
    </div>
  );
}
